module.exports = __webpack_public_path__ + "img/premium_05.ad5ec4c3.png";